<template>
	<section>
		<loader :dialog="loading"></loader>
		<floating-alert
			:message="alertMessage"
			:show="alertShow"
			:type="alertType"
		></floating-alert>

		<!-- Page header -->
		<div class="faq-page-header">
			<div class="faq-page-left">
				<div class="faq-page-icon">
					<v-icon size="20" color="white">mdi-help-circle</v-icon>
				</div>
				<div>
					<p class="faq-page-title">FAQ</p>
					<p class="faq-page-sub">Questions & Réponses</p>
				</div>
			</div>

			<v-dialog v-model="dialog" max-width="500px">
				<template v-slot:activator="{ on, attrs }">
					<v-btn depressed rounded class="faq-add-btn ml-auto" v-bind="attrs" v-on="on">
						<v-icon left small>mdi-plus</v-icon>
						Nouvelle Q&R
					</v-btn>
				</template>
				<v-card rounded="xl" class="pa-2">
					<div class="faq-dialog-header">
						<div class="faq-icon-sm">
							<v-icon size="16" color="white">mdi-help-circle</v-icon>
						</div>
						<div>
							<p class="faq-dialog-title">{{ formTitle }}</p>
							<p class="faq-dialog-sub">Question / Réponse</p>
						</div>
						<v-spacer></v-spacer>
						<v-btn icon small @click="close">
							<v-icon color="#6b7280">mdi-close</v-icon>
						</v-btn>
					</div>
					<v-divider></v-divider>
					<v-card-text class="pt-5">
						<v-text-field
							v-model="questionAnswer.question"
							label="Question"
							outlined
							dense
							rounded
							prepend-inner-icon="mdi-help"
							hide-details
							class="mb-4"
						></v-text-field>
						<v-text-field
							v-model="questionAnswer.answer"
							label="Réponse"
							outlined
							dense
							rounded
							prepend-inner-icon="mdi-comment-text"
							hide-details
						></v-text-field>
					</v-card-text>
					<v-card-actions class="pa-4 pt-2">
						<v-btn text color="error" rounded @click="close">Annuler</v-btn>
						<v-spacer></v-spacer>
						<v-btn depressed rounded class="faq-save-btn" @click="save">Enregistrer</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>

		<!-- Empty state -->
		<div v-if="!loading && questions.length === 0">
			<not-found></not-found>
			<div class="text-center mt-4">
				<v-btn depressed rounded class="faq-add-btn" @click="initialize">
					<v-icon left small>mdi-refresh</v-icon>
					Actualiser
				</v-btn>
			</div>
		</div>

		<!-- FAQ expansion panels -->
		<v-expansion-panels v-else flat class="faq-panels">
			<v-expansion-panel
				v-for="(item, i) in questions"
				:key="i"
				class="faq-panel"
			>
				<v-expansion-panel-header class="faq-panel-header">
					<div class="faq-question-row">
						<div class="faq-q-icon">
							<span class="faq-q-letter">Q</span>
						</div>
						<span class="faq-question-text">{{ item.question }}</span>
					</div>
				</v-expansion-panel-header>
				<v-expansion-panel-content class="faq-panel-content">
					<div class="faq-answer-row">
						<div class="faq-a-icon">
							<span class="faq-a-letter">R</span>
						</div>
						<p class="faq-answer-text">{{ item.answer }}</p>
					</div>
					<div class="faq-actions mt-4">
						<v-btn small rounded outlined color="primary" @click="editItem(item)" class="mr-2">
							<v-icon left x-small>mdi-pencil</v-icon>
							Modifier
						</v-btn>
						<v-btn small rounded outlined color="error" @click="deleteItem(item)">
							<v-icon left x-small>mdi-delete</v-icon>
							Supprimer
						</v-btn>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

		<!-- Delete dialog -->
		<v-dialog v-model="dialogDelete" max-width="440px">
			<v-card rounded="xl" class="pa-2">
				<div class="del-header">
					<div class="del-icon"><v-icon size="18" color="white">mdi-alert</v-icon></div>
					<p class="del-title">Supprimer cette Q&R ?</p>
				</div>
				<v-card-actions class="pa-4 pt-2">
					<v-btn text color="grey" rounded @click="closeDelete">Annuler</v-btn>
					<v-spacer></v-spacer>
					<v-btn depressed rounded class="del-confirm-btn" @click="deleteItemConfirm">Supprimer</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
import services from "../services";
import Loader from "@/components/Loader.vue";
import NotFound from "@/components/Notfound.vue";
import FloatingAlert from "@/components/FloatingAlert.vue";
export default {
	components: { Loader, NotFound, FloatingAlert },
	data: () => ({
		questions: [],
		loading: false,
		dialog: false,
		dialogDelete: false,
		alertMessage: "",
		alertShow: false,
		alertType: "",
		questionAnswer: { question: "", answer: "" },
		defaultQuestionAnswer: { question: "", answer: "" },
		editedIndex: -1,
	}),
	computed: {
		formTitle() { return this.editedIndex === -1 ? "Nouvelle Question/Réponse" : "Modifier la Q&R"; },
	},
	created() { this.initialize(); },
	methods: {
		initialize() {
			this.loading = true;
			services.getQuestions().then((r) => { this.questions = r.data?.questions || r.data || []; this.loading = false; }).catch((e) => { console.log(e); this.loading = false; });
		},
		manageAlert(display, type, message) { this.alertShow = display; this.alertType = type; this.alertMessage = message; },
		save() {
			if (this.editedIndex > -1) {
				this.loading = true;
				services.updateQuestionAnswer(this.questionAnswer, this.questionAnswer._id).then(() => { Object.assign(this.questions[this.editedIndex], this.questionAnswer); this.loading = false; this.close(); this.initialize(); }).catch((e) => { console.log(e); this.loading = false; });
			} else {
				this.loading = true;
				services.addQuestionAnswer(this.questionAnswer).then((r) => { this.close(); this.loading = false; this.manageAlert(true, "success", r.message); this.initialize(); }).catch((e) => { console.log(e); this.loading = false; this.manageAlert(true, "error", e.message); });
			}
		},
		editItem(item) { this.editedIndex = this.questions.indexOf(item); this.questionAnswer = Object.assign({}, item); this.dialog = true; },
		deleteItem(item) { this.editedIndex = this.questions.indexOf(item); this.questionAnswer = Object.assign({}, item); this.dialogDelete = true; },
		deleteItemConfirm() {
			this.loading = true;
			services.deleteQuestionAnswer(this.questionAnswer._id).then((r) => { this.loading = false; this.manageAlert(true, "success", r.message); this.closeDelete(); this.initialize(); }).catch((e) => { this.loading = false; this.manageAlert(true, "error", e.message); });
		},
		close() { this.dialog = false; this.$nextTick(() => { this.questionAnswer = Object.assign({}, this.defaultQuestionAnswer); this.editedIndex = -1; }); },
		closeDelete() { this.dialogDelete = false; this.$nextTick(() => { this.questionAnswer = Object.assign({}, this.defaultQuestionAnswer); this.editedIndex = -1; }); },
	},
};
</script>

<style scoped>
.faq-page-header { display: flex; align-items: center; gap: 14px; margin-bottom: 24px; flex-wrap: wrap; }
.faq-page-left { display: flex; align-items: center; gap: 14px; flex: 1; }
.faq-page-icon { width: 42px; height: 42px; border-radius: 11px; background: linear-gradient(135deg, #c62828, #b71c1c); display: flex; align-items: center; justify-content: center; }
.faq-page-title { font-size: 1rem; font-weight: 800; color: #111827; margin: 0 0 2px; font-family: Montserrat, sans-serif; }
.faq-page-sub { font-size: 0.72rem; color: #9ca3af; margin: 0; font-family: Montserrat, sans-serif; }
.faq-add-btn { background: #c62828 !important; color: white !important; font-family: Montserrat, sans-serif; font-weight: 700; font-size: 0.82rem; }
.faq-panels { border-radius: 12px; overflow: hidden; border: 1px solid #f3f4f6; }
.faq-panel { border-bottom: 1px solid #f3f4f6; font-family: Montserrat, sans-serif; }
.faq-panel:last-child { border-bottom: none; }
.faq-panel-header { padding: 14px 20px; }
.faq-question-row { display: flex; align-items: center; gap: 14px; width: 100%; }
.faq-q-icon { width: 28px; height: 28px; border-radius: 8px; background: linear-gradient(135deg, #c62828, #b71c1c); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.faq-q-letter { font-size: 0.8rem; font-weight: 800; color: white; font-family: Montserrat, sans-serif; }
.faq-question-text { font-size: 0.88rem; font-weight: 700; color: #111827; font-family: Montserrat, sans-serif; }
.faq-panel-content { padding: 0 20px 16px; }
.faq-answer-row { display: flex; align-items: flex-start; gap: 14px; padding-top: 10px; }
.faq-a-icon { width: 28px; height: 28px; border-radius: 8px; background: #eff6ff; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.faq-a-letter { font-size: 0.8rem; font-weight: 800; color: #1565c0; font-family: Montserrat, sans-serif; }
.faq-answer-text { font-size: 0.82rem; color: #374151; line-height: 1.6; margin: 0; font-family: Montserrat, sans-serif; }
.faq-actions { display: flex; gap: 8px; padding-left: 42px; }
.faq-dialog-header { display: flex; align-items: center; gap: 14px; padding: 18px 20px 14px; }
.faq-icon-sm { width: 34px; height: 34px; border-radius: 8px; background: #c62828; display: flex; align-items: center; justify-content: center; }
.faq-dialog-title { font-size: 0.88rem; font-weight: 700; color: #111827; margin: 0 0 2px; font-family: Montserrat, sans-serif; }
.faq-dialog-sub { font-size: 0.68rem; color: #9ca3af; margin: 0; font-family: Montserrat, sans-serif; }
.faq-save-btn { background: #1565c0 !important; color: white !important; font-family: Montserrat, sans-serif; font-weight: 700; font-size: 0.82rem; }
.del-header { display: flex; align-items: center; gap: 12px; padding: 16px 20px 12px; }
.del-icon { width: 34px; height: 34px; border-radius: 8px; background: #c62828; display: flex; align-items: center; justify-content: center; }
.del-title { font-size: 0.9rem; font-weight: 700; color: #111827; margin: 0; font-family: Montserrat, sans-serif; }
.del-confirm-btn { background: #c62828 !important; color: white !important; font-family: Montserrat, sans-serif; font-weight: 700; font-size: 0.82rem; }
</style>

